
import { FormsFeatureContext } from '@ngt/forms';
import { useCallback, useContext } from 'react';
import { ApiManagementUpdateStatusByProjectId, ApiManagementUpdateStatusByStageId, ApiManagementUpdateStatusResponse, FormDefinitions } from '../../api/dtos';

// mutate?: KeyedMutator<IDataSingleResponse<LotProperty>>

export const usePostApiStatusUpdate = () => {
    const formsFeature = useContext(FormsFeatureContext);

    const supportedApiTypes = [
        FormDefinitions.Project,
        FormDefinitions.Stage
    ];


    // @ts-ignore
    const save = useCallback(async (parentFormId?: number, parentFormDefinition?: FormDefinitions, enabled?: boolean, metadata?: Record<string, any>, shouldRevalidate?: boolean) => {
        if(!parentFormDefinition || !supportedApiTypes.includes(parentFormDefinition) || !parentFormId || enabled === undefined) return false;
        const response: ApiManagementUpdateStatusResponse | undefined = 
        parentFormDefinition == FormDefinitions.Stage ? 
            await formsFeature.serviceStackClient.post(new ApiManagementUpdateStatusByStageId({ 
                stageId: parentFormId,
                isActive: enabled
            })) :
        parentFormDefinition == FormDefinitions.Project ?
            await formsFeature.serviceStackClient.post(new ApiManagementUpdateStatusByProjectId({
                projectId: parentFormId,
                isActive: enabled
            })) : undefined;

        return response;
    }, [formsFeature.serviceStackClient]);

    return save;
};

export default usePostApiStatusUpdate;